import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CategoriesEntitiesSelector from "../../../reusable/Form/CategoriesEntitiesSelector";
import { FormattedMessage } from 'react-intl';
import {
    ADD_RSS_SELECT_THIRD_PARTIES_OPTION,
    ADD_RSS_SET_SELECTED_CATEGORIES,
    ADD_RSS_SET_SELECTED_THIRDPARTIES,
    ADD_RSS_CLEAR_SAVE_ERRORS
} from "./BaseFeedEditingComponent.actions";
import { SECTION_CATEGORIES, SECTION_ENTITIES, SECTION_ALL_ENTITIES } from "../../../constants";

// This component is used to act as a translation layer from RSS feed redux to the CategoriesEntitiesSelector

class FeedsThirdPartiesLayer extends Component {
    static propTypes = {
        changeOption: PropTypes.func.isRequired,
        setSelectedCategories: PropTypes.func.isRequired,
        setSelectedEntities: PropTypes.func.isRequired,
        thirdParties: PropTypes.object,
        saveError: PropTypes.object
    }

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }
    
    onChange(changeObj) {
        this.props.changeOption(changeObj.thirdPartySelection);
        switch (changeObj.thirdPartySelection) {
            case SECTION_ALL_ENTITIES:
                this.props.setSelectedCategories([]);
                this.props.setSelectedEntities([]);
                this.props.clearErrors(["api.error.feed.noRiskEntities"]);
                break;
            case SECTION_CATEGORIES:
                this.props.setSelectedCategories(changeObj.selectedCategories);
                this.props.setSelectedEntities([]);
                if (changeObj.selectedCategories.length) {
                    this.props.clearErrors(["api.error.feed.noRiskEntities"]);
                }
                break;
            case SECTION_ENTITIES:
                const selectedEntities = changeObj.selectedThirdPartiesIds.map(id => ({ id }));
                this.props.setSelectedCategories([]);
                this.props.setSelectedEntities(selectedEntities);
                if (selectedEntities.length) {
                    this.props.clearErrors(["api.error.feed.noRiskEntities"]);
                };
                break
        }
    }

    getValues() {
        switch (this.props.thirdParties.thirdPartySelectionBox) {
            case SECTION_ALL_ENTITIES:
                return []
            case SECTION_CATEGORIES:
                return this.props.thirdParties.selectedCategories
            case SECTION_ENTITIES:
                return this.props.thirdParties.selectedThirdParties.map(item => item.id);
        }
    }

    renderErrors() {
        let errors = null;
        if (this.props.saveErrors && this.props.saveErrors.length) {
            this.props.saveErrors.forEach(error => {
                if (error === "api.error.feed.noRiskEntities") {
                    switch (this.props.thirdParties.thirdPartySelectionBox) {
                        case SECTION_CATEGORIES:
                            errors = <FormattedMessage id={"RSS_Add_Error_addRssFeed.thirdParties.noCategoriesError"}/>;
                            break;
                        case SECTION_ENTITIES:
                            errors = <FormattedMessage id="RSS_Add_Error_addRssFeed.thirdParties.noThirdPartiesError" />;
                            break;
                    }
                }
            })
        }
        return errors;
    }
    
    render() {
        return <div className="rss-section__third-parties">

            <div className="title third-parties-title">
                <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.title" />
            </div>
            <CategoriesEntitiesSelector onChange={this.onChange}
                                        section={this.props.thirdParties.thirdPartySelectionBox}
                                        values={this.getValues()}
                                        allEntitiesMsgId={"RSS_Add_UIText_addRssFeed.thirdParties.allThirdPartiesNote"}>
                <div className={'add-rss-error no-third-parties-error shown'}>
                    {this.renderErrors()}
                </div>
            </CategoriesEntitiesSelector>
        </div>
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        thirdParties: Object.assign({}, state.addRssFeed.thirdParties),
        saveErrors: state.addRssFeed.saveErrors
    }
}

const mapDispatchToProps = dispatch => {
    return {
        changeOption: (option) => dispatch({type: ADD_RSS_SELECT_THIRD_PARTIES_OPTION, payload: option}),
        setSelectedCategories: (categories) => dispatch({ type: ADD_RSS_SET_SELECTED_CATEGORIES, payload: categories}),
        setSelectedEntities: (entities) => dispatch({ type: ADD_RSS_SET_SELECTED_THIRDPARTIES, payload: entities}),
        clearErrors: (errors) => dispatch({ type: ADD_RSS_CLEAR_SAVE_ERRORS, payload: errors })
    }
}

const FeedThirdPartiesReduxLayer = connect(
    mapStateToProps,
    mapDispatchToProps
)(FeedsThirdPartiesLayer);

export default FeedThirdPartiesReduxLayer;



// WEBPACK FOOTER //
// ./src/scripts/pages/RSSEditing/BaseFeedEditingComponent/FeedsThirdPartiesReduxLayer.jsx